<template>
    <span class="fa-stack small">
        <i class="fas fa-circle fa-stack-2x"></i>
        <i :class="['fas fa-dollar-sign fa-stack-1x small fa-inverse', { 'warning-color' : isWarning }]"></i>
    </span>
</template>

<script>
export default {
    data() {
        return {
            isWarning: false,
        }
    },
    mounted() {
        this.isWarning = this.$el.classList.contains('text-warning');
    }
}
</script>

<style scoped>
    .fa-stack.small { font-size: 0.666665em; width: 2.5em !important; }
    .fa-stack-1x.small { font-size: 1.3em; }
    .warning-color { color: #555; }
</style>